var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashBinFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4204 6.16406C15.8281 6.16406 16.1108 5.74605 15.9579 5.36273C15.4151 4.00176 14.0984 3.03906 12.5641 3.03906H11.8548C11.5903 1.62215 10.3653 0.5 8.8663 0.5H7.6337C6.13568 0.5 4.90987 1.62141 4.64521 3.03906H3.93593C2.40158 3.03906 1.08494 4.00176 0.542104 5.36273C0.389224 5.74605 0.671911 6.16406 1.07963 6.16406H15.4204ZM7.6337 1.67188H8.8663C9.70985 1.67188 10.4259 2.24742 10.667 3.03906H5.83304C6.07409 2.24742 6.79015 1.67188 7.6337 1.67188ZM2.66686 18.867C2.73115 19.7827 3.49062 20.5 4.3958 20.5H12.1042C13.0093 20.5 13.7688 19.7827 13.8331 18.867L14.6429 7.33594H1.85712L2.66686 18.867ZM9.82999 10.4707C9.84594 10.1475 10.1177 9.89828 10.4359 9.9148C10.7546 9.93098 11 10.2061 10.9841 10.5293L10.6759 16.7793C10.6605 17.0925 10.4052 17.3359 10.0993 17.3359C9.76666 17.3359 9.50539 17.0538 9.5218 16.7207L9.82999 10.4707ZM6.06411 9.9148C6.38239 9.89859 6.6541 10.1476 6.67001 10.4707L6.97816 16.7207C6.99457 17.0539 6.7331 17.3359 6.40061 17.3359C6.09477 17.3359 5.83947 17.0925 5.82403 16.7793L5.51588 10.5293C5.49997 10.2061 5.74541 9.93098 6.06411 9.9148Z",
    fill: "#F44A68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBinFill);
export default __webpack_public_path__ + "static/media/TrashBinFill.a4699ae4.svg";
export { ForwardRef as ReactComponent };